export default __webpack_public_path__ + "static/media/sim_new.6e0c4348.jpg";